import { render, staticRenderFns } from "./mensajeConfirmar.vue?vue&type=template&id=67b071d2"
import script from "./mensajeConfirmar.vue?vue&type=script&lang=js"
export * from "./mensajeConfirmar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports